//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    data: function data() {
        return {
            adminRoles: ['super-admin', 'corporate-admin', 'accounting-admin'],
            offboardRoles: ['super-admin'],
            data: null,
            rolesForSettings: ['super-admin', 'corporate-admin', 'accounting-admin']
        };
    },
    mounted: function mounted() {
        if (this.rolesForSettings.includes(window.validator.role())) {
            this.load();
        }
    },

    methods: {
        load: function load() {
            var self = this;

            axios.get('/prototype/properties/settings').then(function (response) {
                if (response.data) {
                    self.data = response.data;
                }
            });
        },
        show: function show(evt) {
            Event.$emit(evt);
        },
        canEditChargeCodes: function canEditChargeCodes() {
            var canDo = this.adminRoles.includes(window.validator.role());
            if (!canDo) {
                this.$snotify.info("Please contact corporate for assistance.");
            }
            return canDo;
        },
        canOffboardProperty: function canOffboardProperty() {
            var canDo = this.offboardRoles.includes(window.validator.role());
            if (!canDo) {
                this.$snotify.info("Please contact corporate for assistance.");
            }
            return canDo;
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/property/settings/PropertySettings.vue
// module id = SUjE
// module chunks = 0 1